$(function() {
  initializeZeroReportRadioToggleInputs();
  initializePmpSelectInput();
  applyInitialPmpConfigToZeroReportForm();
});

function initializeZeroReportRadioToggleInputs() {
  $('input[name="zero_report_submit_method"]').on("change", function() {
    if ($(this).val() === 'one_click') {
      switchToOneClick();
    } else {
      switchToNewZeroReportForm();
    }
  });
}

function switchToOneClick() {
  showSection('#zero-report-one-click-section', '#zero-report-form-section');

  const url = new URL(window.location);
  url.searchParams.delete('view');
  url.searchParams.delete('pmp_id');
  history.replaceState(null, '', url);
}

function switchToNewZeroReportForm() {
  showSection('#zero-report-form-section', '#zero-report-one-click-section');

  const url = new URL(window.location);
  url.searchParams.set('view', 'form');

  const selectedPmp = $('#zero_report_pmp_id').val();
  if (selectedPmp) {
    url.searchParams.set('pmp_id', selectedPmp);
  }

  history.replaceState(null, '', url);
}

function initializePmpSelectInput() {
  $("#zero_report_pmp_id").on("change", function() {
    const pmpId = this.value;

    updateUrlParam('pmp_id', pmpId);
    applyPmpFieldConfig(pmpId);
  });
}

function applyInitialPmpConfigToZeroReportForm() {
  const initialPmp = $('#zero_report_pmp_id').val();
  if (initialPmp) {
    applyPmpFieldConfig(initialPmp);
  }
}

// --- Helpers ---

function showSection(sectionToShow, sectionToHide) {
  $(sectionToShow).show();
  $(sectionToHide).hide();
}

function updateUrlParam(key, value) {
  const url = new URL(window.location);

  if (value) {
    url.searchParams.set(key, value);
  } else {
    url.searchParams.delete(key);
  }

  history.replaceState(null, '', url);
}

function applyPmpFieldConfig(pmpId) {
  const container = $('#zero-report-form-container');
  const config = container.data('pmp-field-config');

  if (!pmpId || !config || !config[pmpId]) {
    resetIdentifierFields();
    return;
  }

  const pmpConfig = config[pmpId];

  const plnRow = $('#permit-license-number-row');
  const plnInput = plnRow.find('input');
  if (pmpConfig.pln_active) {
    plnRow.show();
    plnInput.prop('disabled', false);
  } else {
    plnRow.hide();
    plnInput.prop('disabled', true).val('');
  }

  updateIdentifierFields(pmpConfig);
}

function resetIdentifierFields() {
  const identifierFields = ['dea_number', 'ncpdp_id', 'national_provider_identifier', 'permit_license_number'];

  identifierFields.forEach(function(field) {
    const fieldContainer = $(`[data-identifier-field="${field}"]`);
    const wrapper = fieldContainer.find('.mb-3');
    const input = fieldContainer.find('input, select');
    const label = fieldContainer.find('label');

    input.attr('aria-required', 'false');
    input.prop('required', false);
    wrapper.removeClass('required');
    label.removeClass('required');
    label.find('abbr').remove();
  });

  $('#permit-license-number-row').hide();
  $('#permit-license-number-row').find('input').prop('disabled', true).val('');
}

function updateIdentifierFields(pmpConfig) {
  const identifierFields = ['dea_number', 'ncpdp_id', 'national_provider_identifier', 'permit_license_number'];

  identifierFields.forEach(function(field) {
    const fieldContainer = $(`[data-identifier-field="${field}"]`);
    const wrapper = fieldContainer.find('.mb-3');
    const input = fieldContainer.find('input, select');
    const label = fieldContainer.find('label');
    const isRequired = pmpConfig.required[field];

    input.attr('aria-required', isRequired ? 'true' : 'false');
    input.prop('required', isRequired);

    if (isRequired) {
      wrapper.addClass('required');
      label.addClass('required');
      if (!label.find('abbr').length) {
        label.append(' <abbr title="required">*</abbr>');
      }
    } else {
      wrapper.removeClass('required');
      label.removeClass('required');
      label.find('abbr').remove();
    }
  });
}
